/*
 * @Descripttion: Box 封装
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-08
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-15 10:42:24
 * @changeLog: 实现立方体对象，支持默认参数、更新与销毁
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Box/index.ts
 */
import type { MeshBasicMaterialParameters } from '@anov/3d-core'
import {
  BoxGeometry,
  Mesh,
  MeshBasicMaterial,
} from '@anov/3d-core'
import _ from 'lodash'
import ObjectLayer from '../Base/ObjectLayer'
import { defineProps } from '../Utils/defineProps'
import type { options } from './types'
import type { IBox } from './interface'

export class Box extends ObjectLayer implements IBox {
  private mesh!: Mesh
  private currentOptions!: options
  constructor(options: options, sceneControl?: any) {
    super(sceneControl)
    this.currentOptions = options
    this.mesh = this.createBox(options)
    this.add(this.mesh)
    defineProps(
      this,
      ['width', 'height', 'length', 'widthSegment', 'heightSegment', 'lengthSegment'],
      ['wireframe', 'color'],
      'updateBox',
    )
  }

  createBox(options: options): Mesh {
    const {
      width = 1,
      height = 1,
      length = 1,
      widthSegment = 1,
      heightSegment = 1,
      lengthSegment = 1,
      material = {},
    } = options

    const defaultMat: MeshBasicMaterialParameters = {
      color: 0xFFFFFF,
      opacity: 1,
      transparent: false,
      wireframe: false,
      visible: true,
    }
    const geometry = new BoxGeometry(width, height, length, widthSegment, heightSegment, lengthSegment)
    geometry.translate(0, height / 2, 0)
    const mat = new MeshBasicMaterial({ ...defaultMat, ...material })
    return new Mesh(geometry, mat)
  }

  /** 更新Box参数 */
  updateBox(options: options): void {
    if (!this.mesh)
      return
    _.mergeWith(this.currentOptions, options)
    this.remove(this.mesh)
    this.mesh.geometry.dispose()
    ;(this.mesh.material as any).dispose()
    this.mesh = this.createBox(this.currentOptions)
    this.add(this.mesh)
  }

  /** 销毁释放资源 */
  public destroy() {
    if (!this.mesh)
      return
    this.remove(this.mesh)
    this.mesh.geometry.dispose()
    ;(this.mesh.material as any).dispose()
    // @ts-ignore
    this.mesh = null
  }
}
